"use strict";
/**
 * Stripe webhook signature verification.
 *
 * The Stripe client is INJECTED as a `constructEvent` callback so this package
 * needs no Stripe dependency, and so the rejection paths are directly testable.
 *
 * FAILS CLOSED in every branch — an unverifiable request is never processed.
 * Requires the RAW request body: correct only for lambda-proxy integration,
 * since an API Gateway request mapping template destroys the raw bytes.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyStripeEvent = verifyStripeEvent;
function verifyStripeEvent(request, constructEvent, secret) {
    const headers = request.headers || {};
    const signature = headers['Stripe-Signature'] || headers['stripe-signature'];
    if (!signature || !request.body)
        return { ok: false, reason: 'missing_signature_or_body' };
    if (!secret)
        return { ok: false, reason: 'secret_not_configured' };
    const rawBody = request.isBase64Encoded
        ? Buffer.from(request.body, 'base64').toString('utf8')
        : request.body;
    try {
        return { ok: true, stripeEvent: constructEvent(rawBody, signature, secret) };
    }
    catch {
        return { ok: false, reason: 'invalid_signature' };
    }
}
//# sourceMappingURL=verifyWebhookSignature.js.map